import { createRouter, createWebHistory } from "vue-router";

const scrollPositions = Object(null);

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "payment",
      component: () => import("../views/PaymentView.vue"),
    },
    {
      path: "/:catchAll(.*)",
      name: "404",
      component: () => import("../views/PageNotFoundView.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && scrollPositions[to.path] !== undefined) {
      document.documentElement.scrollTop = scrollPositions[to.path];
    } else {
      document.documentElement.scrollTop = 0;
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (document.documentElement.classList.contains("app-not-launched")) {
    await new Promise<void>((resolve) => {
      const observer = new MutationObserver(() => {
        observer.disconnect();
        resolve();
      });

      observer.observe(document.documentElement, { attributes: true });
    });
  }

  if (from.path) {
    scrollPositions[from.path] = document.documentElement.scrollTop;
  }

  next();
});

export default router;
